import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE } from "../../Actions/types";

const initialState = {
  loader: false,
  error: false,
  data: null,
};
function loginReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return { ...state, loader: true };

    case LOGIN_SUCCESS:
      return { ...state, data: action.payload, loader: false, error: false };

    case LOGIN_FAILURE:
      return { ...state, error: true, loader: false };

    default:
      return state;
  }
}

export default loginReducer;
